import React from "react";
import { useSelector } from "react-redux";
import Button from "../button";
import ModalTemplate from "./template";
import { State } from "../../../redux/reducers/root";

const ChangePriceModal = () => {
  const doctor = useSelector((state: State) => state.selectDoctor);

  return (
    <ModalTemplate title="کاربر گرامی توجه داشته باشید" icon="far fa-star">
      <div className="p-5 leading-8 text-normal">
        <div>
          با توجه به تغییر مدت زمان هر رزرو برای این مطب، ضروری است که قیمت تعیین شده برای هر رزرو را نیز از طریق قسمت
          مدیریت مطب در پنل بروزرسانی فرمایید.
        </div>
      </div>
      <div>
        <Button className="w-full">
          <a rel="noreferrer" href={`https://assistant.pzkhb.com/doctors/${doctor.id}/offices`}>
            تغییر قیمت
          </a>
        </Button>
      </div>
    </ModalTemplate>
  );
};

export default ChangePriceModal;
